module.exports = __webpack_public_path__ + "img/yuandianjiaofeng1.3df5d545.jpg";